import { render, staticRenderFns } from "./ResultsBlocks.vue?vue&type=template&id=44e75f42&"
import script from "./ResultsBlocks.vue?vue&type=script&lang=js&"
export * from "./ResultsBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports